class GuryouApiConfig {
  // getAccessToken;
  // getApiEndpoint;
  // getProxyApiEndpoint;
}
export { GuryouApiConfig };